import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/global.css';

// Pages
import StreamsPage from './pages/StreamsPage';
import StreamerPage from './pages/StreamerPage';
import ViewerPage from './pages/ViewerPage';

function App() {
  console.log('🔄 App mounted, pathname:', window.location.pathname);
  
  return (
    <BrowserRouter basename="/live">
      <Routes>
        {/* Streams browse page */}
        <Route path="/" element={<StreamsPage />} />
        <Route path="/streams" element={<StreamsPage />} />
        <Route path="/browse" element={<StreamsPage />} />
        
        {/* Streamer dashboard page */}
        <Route path="/streamer/:slug" element={<StreamerPage />} />
        <Route path="/dashboard/:slug" element={<StreamerPage />} />
        
        {/* Viewer pages */}
        <Route path="/watch/:slug" element={<ViewerPage />} />
        <Route path="/:slug" element={<ViewerPage />} />
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
